import {
  NEW_SIGNED_YUESAO_ID,
  YUESAO_ID,
  YUESAO_LEVEL4_CATEGORY_ID,
  UNION_YUESAO_ID,
  E_ORDER_TYPE,
  ORDER_STATE_ENUM,
  ORDER_REFUND_STATE_ENUM,
  ORDER_WORK_STATE_SHANG_HU_ENUM,
  OrderStateToShowTxt_Map,
  SkuTagToOrderState20Key_Map,
  RefundStateToShowTxt_Map,
  WorkStateToShowTxt_Map
} from '@/config'

export { default as B_ORDER_YS } from './ys'
export { default as B_ORDER_Detail } from './detail'
/**
 * 判定是否为甄选月嫂（新新签月嫂）对象
 * @param {Object} 订单对象
 */
export const isNewSelfAsignedMonthInLaw = order => {
  const { useRight, level4CategoryId } = order
  // 甄选月嫂（新新签月嫂） useRight = 6
  // return +useRight === 6 && level4CategoryId === YUESAO_ID
  return +useRight === 6 && YUESAO_LEVEL4_CATEGORY_ID.includes(level4CategoryId)
}
/**
 * 判定是否为新签月嫂对象
 * @param {Object} 订单对象
 */
export const isNewAsignedMonthInLaw = order => {
  const { useRight, level4CategoryId } = order
  // v21.06.01 新新签月嫂 userRight = 6
  // return (+useRight === NEW_SIGNED_YUESAO_ID || +useRight === 6) && level4CategoryId === YUESAO_ID
  return (
    (+useRight === NEW_SIGNED_YUESAO_ID && level4CategoryId === YUESAO_ID) ||
    isNewSelfAsignedMonthInLaw(order)
  )
}
/**
 * 判断订单是否为月嫂订单
 * 包括 签约月嫂订单、联营月嫂订单、新签月嫂订单
 * @typedef {string[]} category_monthInLaws
 * check if level4CategoryId in category_monthInLaws
 * category_monthInLaws = ['10112210','10112210']
 * @param {string} level4CategoryId
 */
export const isMonthInLaw = level4CategoryId =>
  [YUESAO_ID, UNION_YUESAO_ID].indexOf(level4CategoryId) !== -1

export const isUnionYueSao = level4CategoryId =>
  [UNION_YUESAO_ID].indexOf(level4CategoryId) !== -1

export const isRewardType = channelType =>
  E_ORDER_TYPE.REWARD_GIFT === +channelType

/**
 *
 * @param {*} order
 * @returns
 */
export const getOrderSynthesisStateDesc = order => {
  /**
   * "orderState": 10, //10.待支付20.待使用30.待评价40.已完成50.已取消  70.已过期(可选项)
   * "refundState": 10, //10.未申请退款20.已申请退款30.退款完成40退款失败(可选项)
   * "barcodeList"[0]."workState":30,
   * //仅限签约月嫂 上户状态 0:待申请上户 30:已申请上户 35:驳回上户 40:已确认上户
   */
  let {
    orderState,
    refundState,
    skuTag,
    barcodeList,
    workState,
    level4CategoryId
  } = order
  // 订单列表中，直接取workState；订单详情中，通过barcodeList取值
  workState =
    0 == workState || workState
      ? workState
      : barcodeList && barcodeList.length > 0 && barcodeList[0].workState

  //TODO test //待评价
  // workState =40
  // orderState = 30
  // refundState = 10

  // 若 已取消，txt就都“已取消”, 否则
  // 若 退款成功，txt就都“已取消，退款成功”，退款操作会改变orderState为50'已取消', 否则
  // 是 其他状态txt（订单状态txt或上户状态txt）+ 其他退款状态txt,否则
  //// 若 待使用，上户状态有值，上户状态txt + 其他退款状态txt
  //// 若 待使用，上户状态无值，待使用/待服务/待收货 + 其他退款状态txt，否则
  ////若 非待使用，其他订单状态txt + 其他退款状态txt
  //////!注意orderState不为待使用状态时，workState还可能有值
  // let synthesisStateDesc =
  //   ORDER_STATE_ENUM.CANCELED == orderState
  //     ? OrderStateToShowTxt_Map[orderState + '']
  //     : ORDER_REFUND_STATE_ENUM.SUCCESSED == refundState
  //     ? RefundStateToShowTxt_Map[refundState + '']
  //     : (ORDER_STATE_ENUM.TO_BE_USED == orderState &&
  //       (ORDER_WORK_STATE_SHANG_HU_ENUM.DAI_SHENGQING_SHANG_HU == workState
  //         ? '0'
  //         : workState)
  //         ? WorkStateToShowTxt_Map[workState + '']
  //         : ORDER_STATE_ENUM.TO_BE_USED == orderState
  //         ? OrderStateToShowTxt_Map[orderState + ''][
  //             isUnionYueSao(level4CategoryId) //联营月嫂的“待服务”特殊处理为“待使用”
  //               ? '21'
  //               : SkuTagToOrderState20Key_Map[skuTag + ''] || '21'
  //           ]
  //         : OrderStateToShowTxt_Map[orderState + '']) +
  //       RefundStateToShowTxt_Map[refundState + '']

  /* 上面一坨三元运算符的重构 */
  let synthesisStateDesc = ''
  if (ORDER_STATE_ENUM.CANCELED == orderState) {
    // 已取消 -> orderState 50: '已取消'
    synthesisStateDesc = OrderStateToShowTxt_Map[ORDER_STATE_ENUM.CANCELED]
  } else if (ORDER_REFUND_STATE_ENUM.SUCCESSED == refundState) {
    // 退款成功 -> refundState 30: '已取消，退款成功'
    synthesisStateDesc =
      RefundStateToShowTxt_Map[ORDER_REFUND_STATE_ENUM.SUCCESSED]
  } else {
    if (ORDER_STATE_ENUM.TO_BE_USED == orderState && parseInt(workState) >= 0) {
      // 待使用、上户状态有值 -> workState 0: '待上户',30: '待上户',35: '待上户',40: '服务中'
      synthesisStateDesc = WorkStateToShowTxt_Map[workState]
    } else if (ORDER_STATE_ENUM.TO_BE_USED == orderState) {
      // 待使用、上户状态无值 -> orderState 20: '待使用' | '待服务' | '待收货'
      synthesisStateDesc =
        OrderStateToShowTxt_Map[ORDER_STATE_ENUM.TO_BE_USED][
          isUnionYueSao(level4CategoryId) //联营月嫂的“待服务”特殊处理为“待使用”
            ? '21'
            : SkuTagToOrderState20Key_Map[skuTag] || '21'
        ]
    } else {
      // 非待使用 ->  orderState 10: '待支付',30: '待评价',40: '已完成',70: '已过期'
      synthesisStateDesc = OrderStateToShowTxt_Map[orderState]
    }
    // 后面加上其他退款状态 refundState 10: '',20: '，退款中',40: '，退款失败'
    synthesisStateDesc += RefundStateToShowTxt_Map[refundState]
  }

  return synthesisStateDesc
}
